import {useContext, useEffect, useState} from "react";
import { Button, Typography, Dialog, DialogHeader, DialogBody, DialogFooter, Input } from "@material-tailwind/react";
import educationProgramsService from "../../../services/educationPrograms.service";
import { EducationProgram } from "../../../models/EducationPrograms";
import usePagination from "../../../hooks/usePagination";
import './EducationPrograms.css';
import AppTitleContext from "../../../context/AppTitleContext";

const EducationPrograms = () => {
    const [educationPrograms, setEducationPrograms] = useState<EducationProgram[]>([]);
    const [openCreateModal, setOpenCreateModal] = useState(false);
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const [newProgramName, setNewProgramName] = useState("");
    const [programToDelete, setProgramToDelete] = useState<number | null>(null);
    const { updateAppTitle } = useContext(AppTitleContext);
    const { getPagination, currentData } = usePagination<EducationProgram[]>(educationPrograms,7);

    async function getEducationPrograms() {
        let response = await educationProgramsService.getEducationPrograms();
        setEducationPrograms(response);
    }

    const updateEducationProgram = async (id: number, data: EducationProgram) => {
        await educationProgramsService.updateEducationProgram(id, data);
        getEducationPrograms();
    };

    async function deleteEducationProgram(id: number) {
        await educationProgramsService.deleteEducationProgram(id);
        getEducationPrograms();
        setOpenConfirmModal(false);
        setProgramToDelete(null);
    }

    const handleOpenCreateModal = () => {
        setOpenCreateModal(true);
    };

    const handleCloseCreateModal = () => {
        setOpenCreateModal(false);
    };

    const handleCreateProgram = async () => {
        if (newProgramName) {
            await educationProgramsService.createEducationProgram({ name: newProgramName });
            setNewProgramName("");
            handleCloseCreateModal();
            getEducationPrograms();
        }
    };

    const handleOpenConfirmModal = (id: number) => {
        setProgramToDelete(id);
        setOpenConfirmModal(true);
    };

    const handleCloseConfirmModal = () => {
        setOpenConfirmModal(false);
        setProgramToDelete(null);
    };

    useEffect(() => {
        getEducationPrograms();
        updateAppTitle([{title: 'Form'}, {title: 'Programas Educativos'}]);
    }, []);

    return (
        <div className='education-programs'>
            <div className="table-container">
                <div className="flex justify-between items-center w-[100%] my-3">
                    <div>
                        Cantidad total: {educationPrograms.length}
                    </div>
                    <Button
                        color="green"
                        onClick={handleOpenCreateModal}
                        placeholder=''
                    >
                        Agregar Programa Educativo
                    </Button>
                </div>
                <div className="table-wrapper">
                    <table>
                        <thead>
                            <tr>
                                <th className='p-4'>
                                    <Typography
                                        variant="h6"
                                        className="font-normal leading-none"
                                        style={{ color: 'white', fontWeight: 'bold' }}
                                        placeholder=''>
                                        Programa
                                    </Typography>
                                </th>
                                <th className='p-4'>
                                    <p
                                        className="font-normal"
                                        style={{ color: 'white', fontWeight: 'bold' }}>
                                        Acción
                                    </p>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.map((educationProgram, index) => (
                                <tr key={index} className="even:bg-blue-gray-50/50">
                                    <td className="p-4 education-name">
                                        <Typography variant="paragraph" color="blue-gray" placeholder=''>
                                            {educationProgram.name}
                                        </Typography>
                                    </td>
                                    <td className="text-end">
                                        <div className='flex justify-end gap-4 pr-5'>
                                            <Button
                                                color="red"
                                                onClick={() => educationProgram.id !== undefined && handleOpenConfirmModal(educationProgram.id)}
                                                placeholder=''
                                            >
                                                Eliminar
                                            </Button>

                                            <Button
                                                color="blue"
                                                className={educationProgram.isActive ?"edit-button-disabled": "edit-button"}
                                                placeholder=''
                                                onClick={() => educationProgram.id !== undefined && updateEducationProgram(educationProgram.id, { name: educationProgram.name, isActive: !educationProgram.isActive })}
                                            >
                                                {educationProgram.isActive ? "Desactivar" : "Activar"}
                                            </Button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className='pagination'>
                {getPagination()}
            </div>
            <Dialog open={openCreateModal} handler={handleOpenCreateModal} placeholder=''>
                <DialogHeader placeholder=''>Nuevo Programa Educativo</DialogHeader>
                <DialogBody placeholder=''>
                    <Input
                        label="Nombre del Programa Educativo"
                        value={newProgramName}
                        onChange={(e) => setNewProgramName(e.target.value)}
                        placeholder='Ingrese el nombre del programa educativo'
                        crossOrigin=''
                    />
                </DialogBody>
                <DialogFooter placeholder=''>
                    <Button variant="text" color="red" onClick={handleCloseCreateModal} placeholder=''>
                        Cancelar
                    </Button>
                    <Button variant="gradient" color="green" onClick={handleCreateProgram} placeholder=''>
                        Crear
                    </Button>
                </DialogFooter>
            </Dialog>
            <Dialog open={openConfirmModal} handler={handleOpenConfirmModal} placeholder=''>
                <DialogHeader placeholder=''>Confirmar Eliminación</DialogHeader>
                <DialogBody placeholder=''>
                    ¿Estás seguro de que deseas eliminar este programa educativo?
                </DialogBody>
                <DialogFooter placeholder=''>
                    <Button variant="text" color="red" onClick={handleCloseConfirmModal} placeholder=''>
                        Cancelar
                    </Button>
                    <Button variant="gradient" color="green" onClick={() => programToDelete !== null && deleteEducationProgram(programToDelete)} placeholder=''>
                        Confirmar
                    </Button>
                </DialogFooter>
            </Dialog>
        </div>
    );
};

export default EducationPrograms;
